import { api } from '@fno/service/global.js'

export const getAppColors = ({ schoolId }) => api
    .get(`/v2/schools/${schoolId}/appColors`)
    .then(response => response.data)

export const patchAppColors = ({ colors }) => api
    .patch(`/v2/schools/${colors.meta.schoolId}/appColors`, { data: colors })
    .then(response => response.data)
